
import { FunctionArgumentType, FunctionPlugin } from './FunctionPlugin';
export class SqrtPlugin extends FunctionPlugin {
    sqrt(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('SQRT'), Math.sqrt);
    }
}
SqrtPlugin.implementedFunctions = {
    'SQRT': {
        method: 'sqrt',
        parameters: [
            { argumentType: FunctionArgumentType.NUMBER }
        ],
    },
};
